import { Box, Button, Chip, Grid, Stack, Typography } from "@mui/material";
import SEOSite from "../img/New/SEOSite.png";

import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import BugReportIcon from "@mui/icons-material/BugReport";
import LaunchIcon from "@mui/icons-material/Launch";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import SpeedIcon from "@mui/icons-material/Speed";

const SeoAuditLaunchSection = () => {
  return (
    <Box
      sx={{
        py: { xs: 8, sm: 10, md: 16 },
        px: 2,
        background: `
          radial-gradient(
            900px circle at top left,
            rgba(111,214,214,0.18),
            transparent 55%
          ),
          #F7FBFC
        `,
        borderTop: "1px solid rgba(0,0,0,0.04)",
      }}
    >
      <Grid
        container
        spacing={{ xs: 6, md: 8 }}
        alignItems="center" // ✅ IMPORTANT
        maxWidth="1200px"
        mx="auto"
      >
        {/* LEFT CONTENT */}
        <Grid item xs={12} md={6}>
          <Stack alignItems="flex-start" textAlign="left">
            <Chip
              label="🚀 Newly Launched Product"
              sx={{
                mb: 3,
                bgcolor: "rgba(111,214,214,0.25)",
                color: "#124A57",
                border: "1px solid rgba(18,74,87,0.15)",
                fontWeight: 600,
              }}
            />

            <Typography
              fontWeight={800}
              lineHeight={1.15}
              mb={2}
              sx={{
                color: "#0A272D",
                fontSize: {
                  xs: "30px",
                  sm: "36px",
                  md: "46px",
                },
              }}
            >
              AI-Powered SEO Audit <br />
              <Box component="span" sx={{ color: "#124A57" }}>
                Built for Modern Websites
              </Box>
            </Typography>

            <Typography
              mb={4}
              sx={{
                color: "#3A5F66",
                fontSize: { xs: 15, sm: 16, md: 18 },
                maxWidth: 520,
                lineHeight: 1.75,
              }}
            >
              Instantly analyze your website’s SEO health, performance, and
              technical issues. Clear insights. No login. 100% free.
            </Typography>

            <Stack spacing={1.6} mb={5} width="100%">
              <Feature
                icon={<SpeedIcon fontSize="small" />}
                text="Core Web Vitals & Performance"
              />
              <Feature
                icon={<BugReportIcon fontSize="small" />}
                text="Technical & On-Page SEO Issues"
              />
              <Feature
                icon={<PhoneIphoneIcon fontSize="small" />}
                text="Mobile & Desktop Analysis"
              />
              <Feature
                icon={<AutoGraphIcon fontSize="small" />}
                text="Clean & Actionable Reports"
              />
            </Stack>

            <Box width="100%">
              <Button
                variant="contained"
                size="large"
                endIcon={<LaunchIcon />}
                href="https://seo.oglitz.com"
                target="_blank"
                sx={{
                  bgcolor: "#124A57",
                  color: "#FFFFFF",
                  px: { xs: 3.5, md: 4.5 },
                  py: 1.7,
                  borderRadius: "999px",
                  fontWeight: 700,
                  fontSize: 15,
                  width: { xs: "100%", sm: "auto" },
                  boxShadow: "0 12px 30px rgba(18,74,87,0.35)",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#0F3A42",
                  },
                }}
              >
                Run Free SEO Audit
              </Button>
            </Box>

            <Typography mt={2} fontSize={13} color="#6B8F96">
              No login • Free forever • Takes ~30 seconds
            </Typography>
          </Stack>
        </Grid>

        {/* RIGHT VISUAL */}
        {/* RIGHT VISUAL */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: { xs: "center", md: "flex-end" },
              alignItems: "flex-start",
              mt: { xs: 0, md: 0 }, // mobile spacing only
            }}
          >
            <Box
              sx={{
                backgroundColor: "#FFFFFF",
                padding: "10px",
                borderRadius: "20px",
                boxShadow: "0 30px 80px rgba(0,0,0,0.12)",
                maxWidth: "560px",
                width: "100%",
              }}
            >
              {/* PURE IMG TAG */}
              <img
                src={SEOSite}
                alt="SEO Audit Lite Dashboard Preview"
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "420px", // ✅ KEY LINE
                  objectFit: "contain", // keeps proportions
                  display: "block",
                  borderRadius: "14px",
                }}
                loading="lazy"
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SeoAuditLaunchSection;

/* Feature Item */
const Feature = ({ icon, text }) => (
  <Stack direction="row" spacing={1.5} alignItems="center">
    <Box sx={{ color: "#124A57", display: "flex" }}>{icon}</Box>
    <Typography
      sx={{
        color: "#355E66",
        fontSize: { xs: 14, sm: 15 },
        fontWeight: 500,
      }}
    >
      {text}
    </Typography>
  </Stack>
);
